import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    orgId = '', // 为空时查询当前机构的申报表,否则查询该机构的申报表，注：该机构必须是当前机构的下级机构
    depCateId,
    depId,
    industryId,
    search,
    filters = [],
    order = [],
    pi = 1,
    ps = 50,
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.kpi.projKpi.getMyOrgProjKpiPage, {
        orgId,
        depCateId,
        depId,
        industryId,
        search,
        filters,
        order,
        pi,
        ps,
    }, options);
    if (error) return { error, status };
    return content || { rows: [], total: 0, pc: 0, ps, pi };
};
